import React from 'react';
import { Link } from 'react-router-dom';

export default class FooterOne extends React.Component {
    render() {
        let publicUrl = process.env.PUBLIC_URL + '/';
        return (
            <>
                <footer className="footer-one-sec" style={{ background: '#f8f9fa' }}>
                    {/* Keep this element as per your requirement */}
                    {/* <div
                        className="footer-one__top-img"
                        style={{
                            backgroundImage: `url(${publicUrl}assets/images/resources/footer-v1-img3.png)`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '200px',
                            borderRadius: '8px',
                            marginBottom: '20px'
                        }}
                    ></div> */}

                    {/* Copyright Section */}
                    <div className="footer-one__bottom py-4 text-center" style={{ background: '#111' }}>
                        <div className="container">
                            <p style={{ color: '#ccc', margin: 0, fontSize: '15px' }}>
                                © {new Date().getFullYear()} <span style={{ color: '#fff', fontWeight: '600' }}>Nazar Enterprise</span>. All rights reserved.
                            </p>
                        </div>
                    </div>
                </footer>
            </>
        );
    }
}
